import InspectionVehicles from '../../../../components/inspection-vehicles-tag/inspection-vehicles-tag';
import inspectionVehicles from './inspection-vehicles-tag';

export default inspectionVehicles(InspectionVehicles);
